import { DatePicker, DatePickerProps } from "antd";

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export default function DatePickerPtBr(props: DatePickerProps) {
  return <DatePicker {...props} format={DEFAULT_DATE_FORMAT} />;
}
